export default __webpack_public_path__ + "static/media/category.b909f762.png";